import { Drawer } from '@mui/material'
import React, { useContext, useState } from 'react'

import { DrawerRegistroSelDate } from './DrawerRegistroSelDate.component';

/** ICONS */
import ContentPasteIcon from '@mui/icons-material/ContentPaste';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { useEffect } from 'react';
import { GetTimes } from '../api/GetTimes.api';//ok
import LoginContext from '../context/login_context/LoginContext';

export const ViewDrawerRegistros = ({task, ModalLoadded, setModalLoadded,  setTexto, Reload_RH, setReload_RH }) => {
  
  const {LoginState} = useContext(LoginContext);

  const [RegistroBulk, setRegistroBulk] = useState([])
  const [RegistroTime, setRegistroTime] = useState([])
  const [Reload_, setReload_] = useState(0)
// console.log(task.id_work_orders_tasks);
  const [state, setState] = useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });
  const toggleDrawer = (anchor, open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setState({ ...state, [anchor]: open });
  };

  useEffect(() => {
    const GetRegisterNow = async () => {
      let registro_ = await GetTimes({codigo: task.id_work_orders_tasks, planta:LoginState.planta})
      // console.log("REGISTRO:",registro_);
      if(registro_[0]?.initial_date){
        setRegistroTime({initial_date: registro_[0].initial_date, final_date:registro_[0].final_date});
      }
      setRegistroBulk(registro_)
    }
    GetRegisterNow()
    return () => {
      GetRegisterNow()
    }
  }, [Reload_])
  

  return (
    <>

          <div className='container-fluid mb-5 '>
            <div className='row'>
              <div className='col-12 text-center bg-secondary py-1'> 
                <h5 className=' text-center text-white'>Fecha del Trabajo</h5>
              </div>
              <div className='col-12'>
                <small>Tarea: {task.description}</small>
              </div>
              <div className='col-12 mt-5 py-3' style={{borderBottom: '1px soliD #CACACA', borderTop: '1px soliD #CACACA'}}>
                <div className='row'>
                  <div className='col-12'>
                    <span className=''>{task?.user_assigned}</span>
                  </div>
                  <div className='col-12'>
                      <small style={{color: '#9D9D9D', paddingLeft: 10}}>
                      {RegistroTime?.initial_date&&(RegistroTime?.initial_date).split('T')[0].substring(0,10)} {RegistroTime?.initial_date&&(RegistroTime?.initial_date).split('T')[1].substring(0,8)}
                      <span className='px-2'>-</span> 
                      {RegistroTime?.final_date&&(RegistroTime?.final_date).split('T')[0].substring(0,10)} {RegistroTime?.final_date&&(RegistroTime?.final_date).split('T')[1].substring(0,8)}
                    </small>
                  </div>
                </div>
              </div>
              <div className='col-12'>
                <DrawerRegistroSelDate
                  task={task}
                  ModalLoadded={ModalLoadded}
                  setModalLoadded={setModalLoadded}
                  setTexto={setTexto}
                  reload={Reload_}
                  setReload_={setReload_}
                  RegistroBulk={RegistroBulk}
                  Reload_RH={Reload_RH} setReload_RH={setReload_RH}
                />
              </div>
            </div>
          </div>

          {/* ************************************************AGREGAR MODULO  A CONTINUACION COMO VISTA DE DrawerRegistroSelDate************************************************ */}
        
        
    </>
  )
}
